module.exports = __webpack_public_path__ + "static/media/SaveCost.5afae174.svg";